<template>
  <div class="financial-plan-cash-flow">
    <!-- 财务计划现金流量表 -->
    <div class="table-wrapper">
      <div class="table-scroll-area">
        <table class="profit-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>项 目</th>
              <th>合计</th>
              <th
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'header-' + index"
              >
                {{ index }}
              </th>
            </tr>
            <tr>
              <th class="seq-col"></th>
              <th style="text-align: center">建设期/经营期</th>
              <th class="total-col"></th>
              <th
                :colspan="localCashFlowData.constructionPeriod"
                style="font-size: 12px; color: #666; text-align: center"
              >
                建设期
              </th>
              <th
                :colspan="localCashFlowData.operationPeriod"
                style="font-size: 12px; color: #666; text-align: center"
              >
                经营期
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- 经营活动净现金流量 -->
            <tr>
              <td class="seq-col">1</td>
              <td class="item-col">经营活动净现金流量</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.operatingNetCashFlowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-net-cash-flow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.operatingNetCashFlowByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.1</td>
              <td class="item-col">现金流入</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.operatingCashInflowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-cash-inflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.operatingCashInflowByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.1.1</td>
              <td class="item-col">营业收入</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.operatingRevenueTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-revenue-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.operatingRevenueByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.1.2</td>
              <td class="item-col">补贴收入</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.subsidyIncomeTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'subsidy-income-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.subsidyIncomeByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.1.3</td>
              <td class="item-col">其他流入</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.operatingOtherCashInflowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-other-cash-inflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.operatingOtherCashInflowByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.2</td>
              <td class="item-col">现金流出</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.operatingCashOutflowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-cash-outflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.operatingCashOutflowByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.2.1</td>
              <td class="item-col">经营成本</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.operatingCostTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-cost-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.operatingCostByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.2.2</td>
              <td class="item-col">营业税金及附加</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.salesTaxTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'sales-tax-' + index"
              >
                {{
                  formatNumber((cashFlow.salesTaxByYear || [])[index - 1] || 0)
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.2.3</td>
              <td class="item-col">增值税</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.vatTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'vat-' + index"
              >
                {{ formatNumber((cashFlow.vatByYear || [])[index - 1] || 0) }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.2.4</td>
              <td class="item-col">所得税</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.incomeTaxTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'income-tax-' + index"
              >
                {{
                  formatNumber((cashFlow.incomeTaxByYear || [])[index - 1] || 0)
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.2.5</td>
              <td class="item-col">其他流出</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.operatingOtherCashOutflowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-other-cash-outflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.operatingOtherCashOutflowByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>

            <!-- 投资活动净现金流量 -->
            <tr>
              <td class="seq-col">2</td>
              <td class="item-col">投资活动净现金流量</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.investmentNetCashFlowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'investment-net-cash-flow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.investmentNetCashFlowByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.1</td>
              <td class="item-col">现金流入</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.investmentCashInflowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'investment-cash-inflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.investmentCashInflowByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.1.1</td>
              <td class="item-col">回收固定资产余值</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.recoveryFixedAssetsTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'recovery-fixed-assets-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.recoveryFixedAssetsByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.1.2</td>
              <td class="item-col">回收流动资金</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.recoveryWorkingCapitalTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'recovery-working-capital-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.recoveryWorkingCapitalByYear || [])[index - 1] ||
                      0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.2</td>
              <td class="item-col">现金流出</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.investmentCashOutflowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'investment-cash-outflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.investmentCashOutflowByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.2.1</td>
              <td class="item-col">建设投资</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.constructionInvestmentTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'construction-investment-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.constructionInvestmentByYear || [])[index - 1] ||
                      0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.2.2</td>
              <td class="item-col">维持运营投资</td>
              <td class="total-col">
                {{
                  formatNumber(
                    cashFlow.operationMaintenanceInvestmentTotal || 0
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operation-maintenance-investment-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.operationMaintenanceInvestmentByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.2.3</td>
              <td class="item-col">流动资金</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.workingCapitalTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'working-capital-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.workingCapitalByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.2.4</td>
              <td class="item-col">其他流出</td>
              <td class="total-col">
                {{
                  formatNumber(cashFlow.investmentOtherCashOutflowTotal || 0)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'investment-other-cash-outflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.investmentOtherCashOutflowByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>

            <!-- 筹资活动净现金流量 -->
            <tr>
              <td class="seq-col">3</td>
              <td class="item-col">筹资活动净现金流量</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.financingNetCashFlowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'financing-net-cash-flow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.financingNetCashFlowByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.1</td>
              <td class="item-col">现金流入</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.financingCashInflowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'financing-cash-inflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.financingCashInflowByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.1.1</td>
              <td class="item-col">项目资本金投入</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.equityInvestmentTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'equity-investment-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.equityInvestmentByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.1.2</td>
              <td class="item-col">建设投资借款(不含债券)</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.constructionLoanTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'construction-loan-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.constructionLoanByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.1.3</td>
              <td class="item-col">流动资金借款</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.workingCapitalLoanTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'working-capital-loan-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.workingCapitalLoanByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.1.4</td>
              <td class="item-col">债券</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.bondTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'bond-' + index"
              >
                {{ formatNumber((cashFlow.bondByYear || [])[index - 1] || 0) }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.1.5</td>
              <td class="item-col">短期借款</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.shortTermLoanTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'short-term-loan-inflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.shortTermLoanByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.1.6</td>
              <td class="item-col">其他流入</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.financingOtherCashInflowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'financing-other-cash-inflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.financingOtherCashInflowByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.2</td>
              <td class="item-col">现金流出</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.financingCashOutflowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'financing-cash-outflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.financingCashOutflowByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.2.1</td>
              <td class="item-col">各种利息支出</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.利息支出Total || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'interest-expense-' + index"
              >
                {{
                  formatNumber((cashFlow.利息支出ByYear || [])[index - 1] || 0)
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.2.2</td>
              <td class="item-col">偿还债务本金</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.debtPrincipalRepaymentTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'debt-principal-repayment-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.debtPrincipalRepaymentByYear || [])[index - 1] ||
                      0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.2.3</td>
              <td class="item-col">应付利润(股利分配)</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.dividendsTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'dividends-' + index"
              >
                {{
                  formatNumber((cashFlow.dividendsByYear || [])[index - 1] || 0)
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">3.2.4</td>
              <td class="item-col">其他流出</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.financingOtherCashOutflowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'financing-other-cash-outflow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.financingOtherCashOutflowByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>

            <!-- 净现金流量 -->
            <tr>
              <td class="seq-col">4</td>
              <td class="item-col">净现金流量</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.netCashFlowTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'net-cash-flow-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.netCashFlowByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>

            <!-- 累计盈余资金 -->
            <tr>
              <td class="seq-col">5</td>
              <td class="item-col">累计盈余资金</td>
              <td class="total-col">
                {{ formatNumber(cashFlow.surplusFundTotal || 0) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'cumulative-surplus-fund-' + index"
              >
                {{
                  formatNumber(
                    (cashFlow.surplusFundByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { financialPlanCashFlowCalculation, zongmove } from "@/utils/comp.js";

export default {
  name: "FinancialPlanCashFlow",
  data() {
    // 定义计算期长度
    const calcPeriod = 12;

    // 创建指定长度的数组，并用0填充
    const createArray = () => Array(calcPeriod).fill(0);

    return {
      localCashFlowData: {
        cashFlow: {
          // 经营活动现金流量
          operatingCashInflowByYear: createArray(), // 现金流入
          operatingCashInflowTotal: 0,
          operatingRevenueByYear: createArray(), // 营业收入
          operatingRevenueTotal: 0,
          subsidyIncomeByYear: createArray(), // 补贴收入
          subsidyIncomeTotal: 0,
          operatingOtherCashInflowByYear: createArray(), // 其他流入
          operatingOtherCashInflowTotal: 0,

          operatingCashOutflowByYear: createArray(), // 现金流出
          operatingCashOutflowTotal: 0,
          operatingCostByYear: createArray(), // 经营成本
          operatingCostTotal: 0,
          salesTaxByYear: createArray(), // 销售税金及附加
          salesTaxTotal: 0,
          vatByYear: createArray(), // 增值税
          vatTotal: 0,
          incomeTaxByYear: createArray(), // 所得税
          incomeTaxTotal: 0,
          operatingOtherCashOutflowByYear: createArray(), // 其他流出
          operatingOtherCashOutflowTotal: 0,

          operatingNetCashFlowByYear: createArray(), // 经营活动净现金流量
          operatingNetCashFlowTotal: 0,

          // 投资活动现金流量
          investmentCashInflowByYear: createArray(), // 现金流入
          investmentCashInflowTotal: 0,
          recoveryFixedAssetsByYear: createArray(), // 回收固定资产余值
          recoveryFixedAssetsTotal: 0,
          recoveryWorkingCapitalByYear: createArray(), // 回收流动资金
          recoveryWorkingCapitalTotal: 0,

          investmentCashOutflowByYear: createArray(), // 现金流出
          investmentCashOutflowTotal: 0,
          constructionInvestmentByYear: createArray(), // 建设投资
          constructionInvestmentTotal: 0,
          operationMaintenanceInvestmentByYear: createArray(), // 维持运营投资
          operationMaintenanceInvestmentTotal: 0,
          workingCapitalByYear: createArray(), // 流动资金
          workingCapitalTotal: 0,
          investmentOtherCashOutflowByYear: createArray(), // 其他流出
          investmentOtherCashOutflowTotal: 0,

          investmentNetCashFlowByYear: createArray(), // 投资活动净现金流量
          investmentNetCashFlowTotal: 0,

          // 筹资活动现金流量
          financingCashInflowByYear: createArray(), // 现金流入
          financingCashInflowTotal: 0,
          equityInvestmentByYear: createArray(), // 项目资本金投入
          equityInvestmentTotal: 0,
          constructionLoanByYear: createArray(), // 建设投资借款
          constructionLoanTotal: 0,
          workingCapitalLoanByYear: createArray(), // 流动资金借款
          workingCapitalLoanTotal: 0,
          bondByYear: createArray(), // 债券
          bondTotal: 0,
          shortTermLoanByYear: createArray(), // 短期借款
          shortTermLoanTotal: 0,
          financingOtherCashInflowByYear: createArray(), // 其他流入
          financingOtherCashInflowTotal: 0,

          financingCashOutflowByYear: createArray(), // 现金流出
          financingCashOutflowTotal: 0,
          利息支出ByYear: createArray(), // 各种利息支出
          利息支出Total: 0,
          debtPrincipalRepaymentByYear: createArray(), // 偿还债务本金
          debtPrincipalRepaymentTotal: 0,
          dividendsByYear: createArray(), // 应付利润(股利分配)
          dividendsTotal: 0,
          financingOtherCashOutflowByYear: createArray(), // 其他流出
          financingOtherCashOutflowTotal: 0,

          financingNetCashFlowByYear: createArray(), // 筹资活动净现金流量
          financingNetCashFlowTotal: 0,

          // 净现金流量
          netCashFlowByYear: createArray(), // 净现金流量
          netCashFlowTotal: 0,

          // 盈余资金
          surplusFundByYear: createArray(), // 盈余资金

          cumulativeSurplusFundByYear: createArray(), // 累计盈余资金
        },
        calculationPeriod: 15, //
        constructionPeriod: 1,
        operationPeriod: 14,
      },
      cashFlow: {},
    };
  },
  computed: {
    ...mapState(["projectData"]),
  },

  // 启动即调用计算函数
  created() {
    // 先执行所有依赖计算，确保数据完整
    this.$nextTick(() => {
      // 执行主要计算函数，确保所有依赖数据都已准备好，跳过分年投资计划计算
      zongmove();
      // 然后再执行当前组件的计算
      this.localCashFlowData = financialPlanCashFlowCalculation();
      this.cashFlow = this.localCashFlowData.cashFlow;
      console.log("传过来的数据", this.localCashFlowData);
    });
  },

  methods: {
    // 格式化数字显示
    formatNumber(num, decimalPlaces = 2) {
      if (num === null || num === undefined || isNaN(num)) {
        return "";
      }
      // 保留指定位数小数
      const formatted = num.toFixed(decimalPlaces);
      // 如果值为0，则显示为空
      if (parseFloat(formatted) === 0) {
        return "";
      }
      // 返回格式化后的数字
      return formatted;
    },
  },
};
</script>

<style scoped>
.financial-plan-cash-flow {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* 动态高度，确保表格不会超出视口 */
  min-height: 300px;
  max-height: calc(100vh - 200px);
  margin-bottom: 20px;
}

.table-scroll-area {
  flex: 1;
  overflow: auto;
  /* 支持水平和垂直滚动 */
  overflow-x: auto;
  overflow-y: auto;
  /* 确保滚动条可见 */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 美化滚动条 */
.table-scroll-area::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-scroll-area::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-scroll-area::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

.profit-table {
  /* 使用auto而不是fixed，让表格宽度根据内容自动调整 */
  table-layout: auto;
  border-collapse: collapse;
  font-size: 12px;
  /* 当列数少时，表格撑满容器宽度 */
  min-width: 100%;
  /* 确保表格内容不会被压缩 */
  white-space: nowrap;
}

.profit-table th,
.profit-table td {
  text-align: center;
  /* 缩小单元格边框 */
  border: 0.5px solid #dfe6ec;
  /* 设置文字不换行 */
  white-space: nowrap;
  overflow: visible;
  /* 确保不显示省略号 */
  text-overflow: clip;
}

.total-col,
.year-col {
  text-align: right !important;
  padding-right: 10px 1px !important;
}

.profit-table thead th {
  background: #f8f9fa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
}

.seq-col {
  width: 50px;
  min-width: 50px;
}

.item-col {
  text-align: left !important;
  padding-left: 5px;
  padding-right: 10px;
}

.total-col {
  width: 100px;
  min-width: 100px;
  font-weight: 600;
}

.year-col {
  padding: 4px 2px;
  min-width: 60px;
}
</style>
